import { lazy, type ComponentType } from 'react';

const RELOAD_FLAG = 'klinvia:chunk-reload-at';
/** Evita loop de reload se o chunk continuar indisponível. */
const RELOAD_COOLDOWN_MS = 30_000;

function isChunkLoadError(err: unknown): boolean {
  const e = err as { name?: string; message?: string } | null;
  if (!e) return false;
  return e.name === 'ChunkLoadError'
    || /Loading (CSS )?chunk [\w-]+ failed/i.test(e.message || '')
    || /Failed to fetch dynamically imported module/i.test(e.message || '');
}

/**
 * `React.lazy` que, após um deploy (chunks antigos removidos), recarrega a
 * página uma vez para buscar o `index.html` novo em vez de quebrar a tela.
 */
export function lazyPage<T extends ComponentType<any>>(factory: () => Promise<{ default: T }>) {
  return lazy(async () => {
    try {
      return await factory();
    } catch (err) {
      if (isChunkLoadError(err)) {
        const last = Number(sessionStorage.getItem(RELOAD_FLAG) || 0);
        if (Date.now() - last > RELOAD_COOLDOWN_MS) {
          sessionStorage.setItem(RELOAD_FLAG, String(Date.now()));
          window.location.reload();
          return new Promise<{ default: T }>(() => undefined);
        }
      }
      throw err;
    }
  });
}
